import React, { Component, Fragment } from 'react';
import { FaFileInvoice } from 'react-icons/fa';
import { MdPayment } from 'react-icons/md';
import { ArcaHttpClientInvoice } from '../../../code/ArcaHttpClientInvoice';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaSecurity } from '../../../code/ArcaSecurity';
import { ArcaDate } from '../../../code/Types/ArcaDate';
import { ModalPopup } from '../ModalPopup';
import { InvoiceModalPanel } from './InvoiceModalPanel';

export class InvoiceListPanel extends Component {

    constructor(props) {
        super(props);

        var now = new Date();
        var today = new ArcaDate(now)

        this.state = {
            today,
            invoices: null,
            showAreYouSure: false,
            invoiceId: null
        };
    }

    componentDidMount() {
    }


    async onApplyInvoiceClick(invoiceId) {
        this.setState({ showAreYouSure: true, invoiceId })
    }

    async applyInvoice(invoiceId) {
        await ArcaHttpClientInvoice.ApplyInvoice(
            invoiceId,
            (invoice => this.refreshInvoice(invoice)),
            (msg => this.setState({ statusText: msg, isError: true }))
        )
    }

    refreshInvoice(invoice) {
        // this.getInvoiceDetails(this.state.today);
        this.props.onUpdated()
        this.setState({ showAreYouSure: false })
    }

    async onInvoiceClick(invoiceId) {
        await ArcaHttpClientInvoice.GetInvoice(
            invoiceId,
            (invoice => this.setState({ invoice })),
            (msg => this.setState({ statusText: msg, isError: true }))
        )
    }

    render() {
        let { invoices } = this.props;
        let { invoice, today, showAreYouSure, invoiceId } = this.state;
        let warningText =
            <Fragment>
                <p> By confirming this request, the customer will be emailed the invoice directly.
                    <br />
                    <br />
                    <strong>Are you sure you wish to create the invoice?
                        </strong>
                </p>
            </Fragment>


        return (
            <Fragment>


                {invoices ?
                    <table className='table table-striped' aria-labelledby="tabelLabel">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Date</th>
                                {!ArcaHttpSystem.IsSmartphone
                                    ? <th>Status</th>
                                    : <th>-</th>}
                                {!ArcaHttpSystem.IsSmartphone && ArcaSecurity.IsAdmin
                                    ? <th>Name</th>
                                    : null}
                                <th>Total</th>
                                <th>Link</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoices.filter(i => ArcaSecurity.IsAdmin || (i.StatusCode !== 'Created')).map((i, k) =>
                                <tr key={k}>
                                    <td>{i.Id}</td>
                                    <td>{i.Date.DayAndMonthPretty}</td>
                                    {ArcaHttpSystem.IsSmartphone
                                        ? <td>{i.StatusCode.substring(0, 1)}</td>
                                        : <td>{i.StatusCode}</td>}
                                    {!ArcaHttpSystem.IsSmartphone && ArcaSecurity.IsAdmin
                                        ? <td>{i.InvoiceeName}</td>
                                        : null}
                                    <td>{i.CurrencySymbol + i.Total.toFixed(2)}</td>
                                    <td className='minilink'><FaFileInvoice onClick={this.onInvoiceClick.bind(this, i.Id)} /></td>
                                </tr>)}
                        </tbody>
                    </table>
                    : 'Loading ...'}

                {invoice
                    ? <InvoiceModalPanel
                        invoice={invoice}
                        onClose={() => { this.setState({ invoice: null }); this.refreshInvoice() }} />
                    : null}

                {showAreYouSure
                    ? <ModalPopup
                        title='Create Invoice'
                        text={warningText}
                        onCancel={() => this.setState({ showAreYouSure: false })}
                        onConfirm={() => this.applyInvoice(invoiceId)}
                    />
                    : null
                }

            </Fragment>
        );
    }
}